import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import Navigation from "@/components/Navigation";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { MapPin, Calendar, Phone } from "lucide-react";

type MassageCategory = {
  name: string;
  prices: {
    "0,5 h": string;
    "1 h": string;
    "1,5 h": string; // Corresponds to 90 min
    "2 h": string; // Corresponds to 120 min
  };
  isPackageHeader?: boolean;
};

// Updated pricing data based on the provided image
const massageCategories: MassageCategory[] = [
  {
    name: "Klasyczny masaż tajski",
    prices: {
      "0,5 h": "-",
      "1 h": "209 zł",
      "1,5 h": "289 zł",
      "2 h": "369 zł",
    },
  },
  {
    name: "Relaksujący masaż olejkiem",
    prices: {
      "0,5 h": "-",
      "1 h": "229 zł",
      "1,5 h": "309 zł",
      "2 h": "389 zł",
    },
  },
  {
    name: "Relaksujący masaż olejkiem migdałowym",
    prices: {
      "0,5 h": "-",
      "1 h": "239 zł",
      "1,5 h": "319 zł",
      "2 h": "399 zł",
    },
  },
  {
    name: "Masaż gorącym olejkiem kokosowym",
    prices: {
      "0,5 h": "-",
      "1 h": "239 zł",
      "1,5 h": "319 zł",
      "2 h": "399 zł",
    },
  },
  {
    name: "Masaż świecą aromatyczną",
    prices: {
      "0,5 h": "-",
      "1 h": "249 zł",
      "1,5 h": "329 zł",
      "2 h": "409 zł",
    },
  },
  {
    name: "Masaż pleców, głowy i ramion",
    prices: {
      "0,5 h": "145 zł",
      "1 h": "199 zł",
      "1,5 h": "289 zł",
      "2 h": "-",
    },
  },
  {
    name: "Masaż stóp",
    prices: {
      "0,5 h": "129 zł",
      "1 h": "199 zł",
      "1,5 h": "-",
      "2 h": "-",
    },
  },
  {
    name: "Masaż sportowy",
    prices: {
      "0,5 h": "-",
      "1 h": "279 zł",
      "1,5 h": "-",
      "2 h": "-",
    },
  },
  {
    name: "Masaż twarzy Kobido (Nowość!)",
    prices: {
      "0,5 h": "-",
      "1 h": "-",
      "1,5 h": "75 min / 260 zł",
      "2 h": "-",
    },
  },
  {
    name: "PAKIET MASAŻY",
    prices: {
      "0,5 h": "",
      "1 h": "",
      "1,5 h": "",
      "2 h": "",
    },
    isPackageHeader: true,
  },
  {
    name: "Masaż pleców, głowy i ramion + stóp",
    prices: {
      "0,5 h": "-",
      "1 h": "219 zł",
      "1,5 h": "299 zł",
      "2 h": "379 zł",
    },
  },
  {
    name: "Klasyczny masaż tajski + stóp",
    prices: {
      "0,5 h": "-",
      "1 h": "-",
      "1,5 h": "309 zł",
      "2 h": "389 zł",
    },
  },
  {
    name: "Relaksujący masaż olejkiem + stóp",
    prices: {
      "0,5 h": "-",
      "1 h": "-",
      "1,5 h": "329 zł",
      "2 h": "409 zł",
    },
  },
  {
    name: "Relaksujący masaż olejkiem migdałowym + stóp",
    prices: {
      "0,5 h": "-",
      "1 h": "-",
      "1,5 h": "339 zł",
      "2 h": "419 zł",
    },
  },
  {
    name: "Masaż gorącym olejkiem kokosowym + stóp",
    prices: {
      "0,5 h": "-",
      "1 h": "-",
      "1,5 h": "339 zł",
      "2 h": "419 zł",
    },
  },
  {
    name: "Masaż świecą aromatyczną + stóp",
    prices: {
      "0,5 h": "-",
      "1 h": "-",
      "1,5 h": "349 zł",
      "2 h": "429 zł",
    },
  },
  {
    name: "Masaż sportowy + stóp",
    prices: {
      "0,5 h": "-",
      "1 h": "-",
      "1,5 h": "389 zł",
      "2 h": "-",
    },
  },
];

const Pricing = () => {
  const scrollToVouchers = () => {
    const vouchersSection = document.getElementById("vouchers-carnets");
    if (vouchersSection) {
      vouchersSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-dark">
      <Navigation />
      <div className="container mx-auto px-4 pt-32 pb-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-gold mb-4">
            Cennik Masaży ChaBa Thai Massage
          </h1>
          <p className="text-gold-light/80 mb-8">
            Odkryj naszą kompleksową ofertę masaży
          </p>
          
          <Button 
            onClick={scrollToVouchers}
            className="bg-gold text-dark hover:bg-gold-dark transition-colors mb-8"
          >
            Sprawdź nasze vouchery i karnety
          </Button>
        </motion.div>

        <div className="bg-dark-light/50 backdrop-blur-sm rounded-lg shadow-xl border border-gold/10 overflow-hidden overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="border-b border-gold/20 bg-gold/10 hover:bg-gold/20">
                <TableHead className="text-gold text-lg font-bold">RODZAJ MASAŻU</TableHead>
                <TableHead className="text-gold text-lg font-bold text-center">0,5 h</TableHead>
                <TableHead className="text-gold text-lg font-bold text-center">1 h</TableHead>
                <TableHead className="text-gold text-lg font-bold text-center">1,5 h</TableHead>
                <TableHead className="text-gold text-lg font-bold text-center">2 h</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {massageCategories.map((category, categoryIndex) => (
                <TableRow
                  key={categoryIndex}
                  className={`border-b border-gold/10 transition-colors ${
                    category.isPackageHeader 
                      ? "bg-gold/20 hover:bg-gold/20" 
                      : "hover:bg-gold/5"
                  }`}
                >
                  <TableCell className={`font-medium ${
                    category.isPackageHeader 
                      ? "text-gold text-lg font-bold text-center" 
                      : "text-gold-light"
                  }`}>
                    {category.name}
                  </TableCell>
                  <TableCell className={`text-center ${
                    category.isPackageHeader 
                      ? "text-gold text-lg font-bold" 
                      : "text-gold-light"
                  }`}>{category.prices["0,5 h"]}</TableCell>
                  <TableCell className={`text-center ${
                    category.isPackageHeader 
                      ? "text-gold text-lg font-bold" 
                      : "text-gold-light"
                  }`}>{category.prices["1 h"]}</TableCell>
                  <TableCell className={`text-center ${
                    category.isPackageHeader 
                      ? "text-gold text-lg font-bold" 
                      : "text-gold-light"
                  }`}>{category.prices["1,5 h"]}</TableCell>
                  <TableCell className={`text-center ${
                    category.isPackageHeader 
                      ? "text-gold text-lg font-bold" 
                      : "text-gold-light"
                  }`}>{category.prices["2 h"]}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>

        <div className="mt-8 mb-16 text-center">
          <p className="text-gold-light/60 text-sm">
            * Ceny mogą ulec zmianie. Prosimy o potwierdzenie aktualnej ceny podczas rezerwacji.
          </p>
        </div>
        
        {/* Vouchers and Membership Cards Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          id="vouchers-carnets"
          className="mt-20 grid md:grid-cols-2 gap-8"
        >
          <div className="bg-dark-light/50 backdrop-blur-sm rounded-lg shadow-xl border border-gold/10 p-8">
            <h2 className="text-2xl md:text-3xl font-bold text-gold mb-4">VOUCHERY</h2>
            <p className="text-gold-light leading-relaxed mb-4">
              Vouchery prezentowe na kwotę lub wybrany masaż dla bliskich osób. Warto podarować chwilę relaksu i wytchnienia.
            </p>
            <p className="text-gold-light leading-relaxed">
              Voucher prezentowe do wykorzystania w okresie 3 miesięcy.
            </p>
            <div className="mt-6">
              <div className="flex items-center gap-4">
                <Button
                  onClick={() => window.location.href = "tel:733503287"}
                  className="bg-gold text-dark hover:bg-gold-dark transition-colors"
                >
                  Zadzwoń teraz
                </Button>
                <span className="text-gold-light">733 503 287</span>
              </div>
            </div>
          </div>
          
          <div className="bg-dark-light/50 backdrop-blur-sm rounded-lg shadow-xl border border-gold/10 p-8">
            <h2 className="text-2xl md:text-3xl font-bold text-gold mb-4">KARNETY</h2>
            <p className="text-gold-light leading-relaxed mb-4">
              Karnety kwotowe na masaż, wygodne, idealne dla osób które regularnie korzystają z masaży lub chcą obdarować bliskich praktycznymi prezentami.
            </p>
            <p className="text-gold-light leading-relaxed">
              Karnety wartościowe do wykorzystania w okresie 6 miesięcy.
            </p>
            <div className="mt-6">
              <div className="flex items-center gap-4">
                <Button
                  onClick={() => window.location.href = "tel:733503287"}
                  className="bg-gold text-dark hover:bg-gold-dark transition-colors"
                >
                  Zadzwoń teraz
                </Button>
                <span className="text-gold-light">733 503 287</span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Quick Info Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="mt-20"
        >
          <div className="bg-dark-light/50 backdrop-blur-sm rounded-lg shadow-xl border border-gold/10 p-8">
            <div className="grid md:grid-cols-3 gap-8">
              <div className="flex items-center justify-center space-x-4">
                <MapPin className="text-gold w-8 h-8 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-gold">Lokalizacja</h3>
                  <p className="text-gold-light">Leszczynowa 20/U11</p>
                  <p className="text-gold-light">76-200 Słupsk</p>
                </div>
              </div>
              <div className="flex items-center justify-center space-x-4">
                <Calendar className="text-gold w-8 h-8 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-gold">Godziny otwarcia</h3>
                  <p className="text-gold-light">Poniedziałek: 10:00 - 20:00</p>
                  <p className="text-gold-light">Wtorek: 10:00 - 20:00</p>
                  <p className="text-gold-light">Środa: Zamknięte</p>
                  <p className="text-gold-light">Czwartek: 10:00 - 20:00</p>
                  <p className="text-gold-light">Piątek: 10:00 - 20:00</p>
                  <p className="text-gold-light">Sobota: 10:00 - 20:00</p>
                  <p className="text-gold-light">Niedziela: 10:00 - 20:00</p>
                </div>
              </div>
              <div className="flex items-center justify-center space-x-4">
                <Phone className="text-gold w-8 h-8 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-gold">Rezerwacje</h3>
                  <p className="text-gold-light">733 503 287</p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Pricing;
